import  {VendorOnboardingDropdownExamples}  from "@/mocks/data/vendorOnboardingService/vendorOnboarding";
import { vendorWelcomeEmailData } from '@/mocks/data/vendorOnboardingService/vendorWelcomeEmailLinks';
import api from "./api";
// types
import { IGetSiteListPayload } from "@/types/VendorManagement.types";
import { AuditInformationQuestionnaire } from "@/components/FoodSafety/types";

const { vendorServiceAPI } = api;

const GET_VENDOR_ONBOARDING_INFO_PATH = "/vendorOnboarding/getOnboardingInfo";
const GET_VENDOR_ONBOARDING_DETAILS_PATH = "/vendorOnboarding/getOnboardingDetails";
const SEND_WELCOME_EMAIL_PATH = "/vendorOnboarding/sendWelcomeEmail";
const GET_VENDOR_SITE_ONLOAD_PATH = "/vendor/site/onload";
const GET_VENDOR_SITE_LIST_PATH = "/vendor/site/list";
const GET_AUDIT_QUESTIONNAIRE_PATH = "/api/audit-questionnaire";
const SAVE_VENDOR_ONBOARDING_INFO_PATH = "/vendorOnboarding/save";

const vendorOnboardingService = {
    getPrePanelDropdownData: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        const resp = VendorOnboardingDropdownExamples.vendorPrePanelComponent;
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            throw error;
        }

    },
    getSiteList: async (payload: IGetSiteListPayload) => {
      try {
        const resp = await vendorServiceAPI.post( GET_VENDOR_SITE_LIST_PATH, payload );
        console.log("Vendor Site List: ", resp.status);
        return resp;
      } catch (error) {
        throw error;
      }
    },
    // Vendor Basic Information removed
    getSiteDetailsDropdownData: async (): Promise<any> =>{
        try {
        // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
        // const resp = VendorOnboardingDropdownExamples.vendorSiteDetailsComponent;
        const resp = await vendorServiceAPI.get(GET_VENDOR_SITE_ONLOAD_PATH);
        return resp ? resp : null;
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            throw error;
        }
    },
    getVendorOnboardingInfo: async (vendorAssessmentID: string, ideaId: string) => {
        try {
          const resp = await vendorServiceAPI.get(`${GET_VENDOR_ONBOARDING_INFO_PATH}?vendorAssessmentId=${vendorAssessmentID}&ideaId=${ideaId}`);
          return resp.data;
        } catch (error) {
          throw error;
        }
      },
      getVendorOnboardingDetails: async (vendorId: string) => {
        try {
          const resp = await vendorServiceAPI.get(`${GET_VENDOR_ONBOARDING_DETAILS_PATH}?vendorId=${vendorId}`);
          return resp.data;
        } catch (error) {
          throw error;
        }
      },
      sendWelcomeEmail: async (payload: any, vendorUserId?: string) => {
        try {
          // If vendorUserId is provided, append it to the URL path
          if (vendorUserId) {
            const resp = await vendorServiceAPI.post(`${SEND_WELCOME_EMAIL_PATH}/${vendorUserId}`, payload);
            return resp.data;
          } else {
            // Otherwise, use the old endpoint without vendorUserId
            const resp = await vendorServiceAPI.post(SEND_WELCOME_EMAIL_PATH, payload);
            return resp.data;
          }
        } catch (error) {
          throw error;
        }
      },
      getAuditQuestionnaire: async (fsvpType: 'FSVP1' | 'FSVP2'): Promise<{
        success: boolean;
        data: {
          fsvpType: string;
          answers: { value: string; label: string }[];
          questions: AuditInformationQuestionnaire[];
        };
      }> => {
        try {
          const response = await fetch(`${GET_AUDIT_QUESTIONNAIRE_PATH}/${fsvpType.toLowerCase()}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `HTTP error. status: ${response.status}`);
          }

          const data = await response.json();
          return data;
        } catch (error) {
          console.error('Error fetching audit questionnaire:', error);
          throw error;
        }
      },
      saveVendorOnboardingInfo: async (payload: any) => {
        try {
          const resp = await vendorServiceAPI.post(SAVE_VENDOR_ONBOARDING_INFO_PATH, payload);
          return resp.data;
        } catch (error) {
          throw error;
        }
      },

};

export default vendorOnboardingService;